<template>
    <div class="m-video u-overflowHidden u-br u-posRelative">
      <div ref="videoContainer" class="m-video__video u-posAbsolute">
        <Loader v-if="loading" />
      </div>
    </div>
    <h3 v-if="item?.title" class="o-video__title u-mt10">{{ item.title }}</h3>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Player from '@vimeo/player';
import Loader from './Loader.vue';
  
const modelValue = defineModel('modelValue', { type: Boolean, default: false });
  
const props = defineProps({
    item: {
      type: Object,
      required: true,
    }
});
  
const playing = ref(false);
const loading = ref(false);
const videoContainer = ref(null);
let vimeoPlayer = null;
  
const playVideo = (autoplay = false) => {
    if (!vimeoPlayer) {
      loading.value = true;
  
      vimeoPlayer = new Player(videoContainer.value, {
        url: props.item.video,
        autoplay: autoplay,
        loop: false,
      });
  
      vimeoPlayer.on('loaded', () => {
        loading.value = false;
        if (autoplay) {
          vimeoPlayer.play();
          playing.value = true;
        }
      });
  
      vimeoPlayer.on('ended', () => {
        modelValue.value = true;
      });
    } else if (autoplay) {
      vimeoPlayer.play().then(() => {
        playing.value = true;
      });
    }
};
  
onMounted(() => {
    if (props.item.video) {
      playVideo(false); // Always load immediately
    }
});
</script>  